import React from 'react';
import './ExamPlanDetail.css';

export default function AssessmentInclusions({ included = [] }) {
  return <aside className="checkout-right assessment-detail__inclusions">
    <div className="checkout-right__header assessment-detail__inclusions-header"><h2>Inclusions</h2><span>{included.length} {included.length === 1 ? 'Item' : 'Items'}</span></div>
    <div className="checkout-right__subjects"><div className="checkout-subject assessment-detail__inclusions-card">
      {included.length ? <div className="checkout-subject__content-list">{included.map(item => <div className="checkout-subject__content-item checkout-subject__content-item--active" key={item.id}><span className="checkout-subject__content-icon"><i className="bi bi-check-lg" aria-hidden="true" /></span><span>{item.name}</span></div>)}</div> : <p>No inclusions available for this plan.</p>}
    </div></div>
  </aside>;
}
